import { render, staticRenderFns } from "./TestModal.vue?vue&type=template&id=daf8281a&scoped=true&"
import script from "./TestModal.vue?vue&type=script&lang=js&"
export * from "./TestModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "daf8281a",
  null
  
)

export default component.exports